import { createContext } from "react";
import { Store } from "../../shared/types";

//@ts-ignore this will never be empty
export const StoreContext = createContext<Store>({ locale: {} });
